import { useQuery } from "@apollo/client";
import { useEffect, useMemo, useRef, useState } from "react";
import GetClientProfileForShouldCreateGatheringPromptDocument from "src/api/graphql/__generated__/documents/GetClientProfileForShouldCreateGatheringPromptDocument";
import { useGatheringStore } from "src/contexts/GatheringContext";
import { useClientId } from "src/helpers/globalHelpers";

const useShouldCreateGatheringPrompt = () => {
	const ownerId = useGatheringStore((state) => state.ownerId);
	const clientId = useClientId();
	const { data, refetch, loading } = useQuery(
		GetClientProfileForShouldCreateGatheringPromptDocument,
		{
			fetchPolicy: "cache-first",
		},
	);
	const numGatheringsOwned = useMemo(
		() => data?.getClientProfile?.numGatheringsOwned ?? 0,
		[data?.getClientProfile?.numGatheringsOwned],
	);
	const [hasNoGatherings, setHasNoGatherings] = useState(
		loading ? data?.getClientProfile?.numGatheringsOwned === 0 : numGatheringsOwned === 0,
	);

	const didRefetch = useRef(false);
	useEffect(() => {
		if (!didRefetch.current) {
			if (numGatheringsOwned === 0) {
				didRefetch.current = true;
				refetch();
			}
		}
	}, [numGatheringsOwned, refetch]);
	const didSet = useRef(false);
	useEffect(() => {
		if (!didSet.current && !loading) {
			didSet.current = true;
			setHasNoGatherings(numGatheringsOwned === 0);
		}
	}, [loading, numGatheringsOwned]);
	const shouldCreateGatheringPrompt = useMemo(
		() => hasNoGatherings && ownerId !== clientId,
		[clientId, hasNoGatherings, ownerId],
	);
	return shouldCreateGatheringPrompt;
};
export default useShouldCreateGatheringPrompt;
